import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getTopicsForSurvey } from "../api/getTopics";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getTopicsForSurvey;

type UseTopicsForSurveyOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useTopicsForSurvey = ({ config }: UseTopicsForSurveyOptions = {}) => {
  const filters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,  // No hacer refetch al montar si no est� obsoleto
    refetchOnWindowFocus: false,  // No hacer refetch al enfocar la ventana
    retry: false,                     // Disable automatic retries
    //retryOnMount: false,              // Prevent refetching on mount if it previously failed
    queryKey: ["topics", filters],/*[surveysQueryKeys.topics.all],*/
    queryFn: () => getTopicsForSurvey(filters),
  });
}